import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="dura-pick"
export default class extends Controller {

  static targets = ["modal", 'input', "dummy"]

  connect() {
    const inputField = this.element.querySelector('.booking_duration');
    if(inputField){
      inputField.addEventListener('click', () => {
        this.open();
      })
    }
    this.buttonHandler();
    this.inputTarget.addEventListener('change', () => {
      this.labelChange();
    })
  }

  buttonHandler() {
    const buttons = this.element.querySelectorAll('.duration_btn');
    buttons.forEach(button => {
      button.addEventListener('click', () => {
        if(button.classList.contains('active')){
          button.classList.remove('active');
        } else if(!button.classList.contains('unav')){
          buttons.forEach(button => {
            button.classList.remove('active');
          });
          button.classList.toggle('active');
        }
        this.labelChange();   
      })
      const dataValue = button.getAttribute('data-value');
      const text = button.innerText
      if(this.inputTarget.value == dataValue){
        this.dummyTarget.innerText = text;
      }
    });
  }

  labelChange() {
    const selectedText = this.element.querySelector('.duration_btn.active').innerText;
    this.dummyTarget.innerText = selectedText;
  }

  open() {
    this.modalTarget.classList.add('open');
  }

  close() {
    this.modalTarget.classList.remove('open');
  }

  submit() {
    const selectedVal = this.element.querySelector('.duration_btn.active').getAttribute('data-value');
    this.inputTarget.value = selectedVal;
    this.modalTarget.classList.remove('open');
  }
}
